import React from 'react';

import DefaultTemplate from 'src/templates/default';
import { PricingTable } from 'src/components/DataDisplay';

import { CmsThemes, Locales } from 'src/lib/constants';

import { metaData, pricingTableData } from 'src/store/en-eu/pricing';
import MainNavigationSpacer from 'src/components-v2/MainNavigationBar/MainNavigationSpacer';

export default ({ locale = Locales.EN_EU }) => {
  return (
    <DefaultTemplate {...metaData} locale={locale} cmsTheme={CmsThemes.WEB3}>
      <MainNavigationSpacer />
      <PricingTable {...pricingTableData} />
    </DefaultTemplate>
  );
};
